export const searchFormOption = function () {
  return [
    {
      prop: "keyword",
      label: "关键字",
      type: "input",
      placeholder: "请输入服务单编号/流水号/车牌号",
    },
    {
      prop: "orgNo",
      label: "所属机构",
      type: "cascader",
      placeholder: "请选择所属机构",
      propConfig: {
        value: "id",
        label: "orgName",
        emitPath: false,
      },
      options: this.orgOption,
    },
  ];
};

export default {};
